import { z } from "zod";
export const ErrorEnvelopeSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.string(), z.unknown()).optional(),
    }),
});
export const HealthResponseSchema = z.object({
    ok: z.literal(true),
    version: z.string(),
    uptime_s: z.number().nonnegative(),
});
//# sourceMappingURL=common.js.map